import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { gql } from '@yi/core';

import {
  ContentCardMenu,
  LearnArticle,
  RelatedArticlesCarousel,
  ShareIconsGroup,
} from '~/components';
import { useCurrentUser } from '~/src/common/user';

import { ArticleHeading } from './ArticleHeading';
import { ArticleBody, BannerImage, FavoriteButtonWrapper } from './elements';
import { ParseArticleBody } from './ParseArticleBody';
import { PoseCategorySection } from './PoseCategorySection';
import { PrevNextContent } from './PrevNextContent';
import { Progress } from './Progress';
import { RelatedContent } from './RelatedContent';

interface Props {
  pose: gql.typesSsr.Query_Pose_yi_Pose;
}

export const PoseContent: React.FC<PropsWithChildren<Props>> = ({ pose }) => {
  const { isLoggedIn } = useCurrentUser();

  return (
    <LearnArticle
      preContent={<Progress contentId={pose.id} />}
      content={
        <>
          <BannerImage img={`url('${pose.no_text_image.processed_url}')`}>
            {isLoggedIn ? (
              <Box
                mt={{ xs: '68px', sm: '80px', lg: '85px' }}
                textAlign="right"
                pr={{ xs: '2vw', md: '1.2vw' }}
              >
                <FavoriteButtonWrapper>
                  <ContentCardMenu contentId={pose.id} contentTitle={pose.title} />
                </FavoriteButtonWrapper>
              </Box>
            ) : null}
          </BannerImage>
          <ArticleHeading content={pose} isPoseContent />
          <Container maxWidth="xl">
            <ShareIconsGroup
              title={pose.title}
              url_title={pose.url_title}
              full_url={pose.full_url}
            />
            <ArticleBody id="learn-article-{entry_id}">
              <PoseCategorySection pose={pose} />
              <ParseArticleBody parsed_body={pose.parsed_body} />
            </ArticleBody>
          </Container>
        </>
      }
    >
      <RelatedContent
        renderRelatedCarousel={() => <RelatedArticlesCarousel relatedToContentId={pose.id} />}
      />
      <PrevNextContent
        nextPath={pose.next?.localized_path || null}
        prevPath={pose.prev?.localized_path || null}
      />
    </LearnArticle>
  );
};
